import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { extendObservable } from 'mobx'
import PropTypes from 'prop-types'

import Checkbox from '@components/Checkbox'
import Radio from '@components/Radio'
import Spinner from '@components/spinner'

class Filters extends Component {
  static propTypes = {
    eplStore: PropTypes.object
  }

  constructor (props) {
    super(props)

    extendObservable(this, {
      query: {
        filter: null,
        options: []
      }
    })
  }

  renderFilterGroup = filterGroup => {
    const { loadingFilters, filterGroups, changeOption } = this.props.eplStore
    const filterOptions = filterGroups[filterGroup].options

    if (loadingFilters || !filterOptions.length) return 'No options'

    return filterOptions.map(option => {
      return (
        <div
          className='filters-wrapper__group__checkbox'
          key={option.id}
          onClick={() => changeOption(filterGroup, option.id)}
        >
          <Checkbox value={option.checked} />
          <label className='filters-wrapper__group__checkbox-label'>
            {option.name || 'Unnamed Segment'}
          </label>
        </div>
      )
    })
  }

  render () {
    const {
      changeFilter,
      doShowGroupsAndFilters,
      loadingFilters,
      filterGroups,
      isExpertQuickSearchActive
    } = this.props.eplStore

    if (!filterGroups || !doShowGroupsAndFilters) return null
    if (loadingFilters) return <Spinner />

    let wrapperClassName = 'filters-wrapper'
    if (isExpertQuickSearchActive) {
      wrapperClassName += ' filters-wrapper__disabled'
    }

    return (
      <div className={wrapperClassName}>
        <form>
          <div className='filters-wrapper__group'>
            <div
              className='filters-wrapper__group__radio'
              onClick={e => changeFilter('eplStatuses')}
            >
              <Radio
                checked={filterGroups.eplStatuses.checked}
                onChange={() => {}}
              />
              <label>Status</label>
            </div>
            <div className='filters-wrapper__group__list'>
              {this.renderFilterGroup('eplStatuses')}
            </div>
          </div>

          <div className='filters-wrapper__group'>
            <div
              className='filters-wrapper__group__radio'
              onClick={e => changeFilter('segments')}
            >
              <Radio
                checked={filterGroups.segments.checked}
                onChange={() => {}}
              />
              <label>Segments</label>
            </div>
            <div className='filters-wrapper__group__list'>
              {this.renderFilterGroup('segments')}
            </div>
          </div>

          <div className='filters-wrapper__group'>
            <div
              className='filters-wrapper__group__radio'
              onClick={e => changeFilter('deliveredBy')}
            >
              <Radio
                checked={filterGroups.deliveredBy.checked}
                onChange={() => {}}
              />
              <label>Delivered by</label>
            </div>
            <div className='filters-wrapper__group__list'>
              {this.renderFilterGroup('deliveredBy')}
            </div>
          </div>

          <div className='filters-wrapper__group'>
            <div
              className='filters-wrapper__group__radio'
              onClick={e => changeFilter('replyStatuses')}
            >
              <Radio
                checked={filterGroups.replyStatuses.checked}
                onChange={() => {}}
              />
              <label>Reply status</label>
            </div>
            <div className='filters-wrapper__group__list'>
              {this.renderFilterGroup('replyStatuses')}
            </div>
          </div>
        </form>
      </div>
    )
  }
}

export default inject('eplStore')(observer(Filters))
